import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { RocketIcon, CodeIcon, UsersIcon, ServerIcon, ArrowRightIcon } from 'lucide-react';
const stagger = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.1
    }
  }
};
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 16
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  }
};
export function AskSlide() {
  return <motion.div className="w-full h-full flex flex-col px-12 py-10" variants={stagger} initial="hidden" animate="visible" data-id="element-60">
      <motion.div variants={fadeUp} className="flex items-center gap-3 mb-2" data-id="element-61">
        <span className="text-base text-[#ff6b35] font-semibold tracking-widest uppercase" data-id="element-62">
          10
        </span>
        <span className="w-8 h-[1px] bg-[#ff6b35] opacity-50" data-id="element-63" />
      </motion.div>

      <motion.h2 variants={fadeUp} className="text-4xl md:text-5xl font-extrabold text-white mb-3" data-id="element-64">
        Ask / Closing
      </motion.h2>

      <motion.div variants={fadeUp} className="flex items-baseline gap-3 mb-8" data-id="element-65">
        <p className="text-3xl font-bold text-[#00d4ff]" data-id="element-66">Raising $5M</p>
        <p className="text-2xl text-[#8899aa]" data-id="element-67">
          pre-seed to launch, scale capacity, and land first 100 customers
        </p>
      </motion.div>

      <motion.p variants={fadeUp} className="text-base text-[#8899aa] uppercase tracking-widest font-semibold mb-4" data-id="element-68">
        Use of Funds
      </motion.p>

      <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-69">
        <motion.div variants={fadeUp} className="glass-card p-5 flex gap-4 items-start" data-id="element-70">
          <div className="w-9 h-9 rounded-lg bg-[rgba(0,212,255,0.1)] flex items-center justify-center flex-shrink-0" data-id="element-71">
            <CodeIcon className="w-4 h-4 text-[#00d4ff]" data-id="element-72" />
          </div>
          <div data-id="element-73">
            <p className="text-xl font-bold text-white mb-1" data-id="element-74">Product</p>
            <p className="text-[17px] text-white/70 leading-relaxed" data-id="element-75">
              Expand model support, optimize inference pipelines, build
              developer tools
            </p>
          </div>
        </motion.div>

        <motion.div variants={fadeUp} className="glass-card p-5 flex gap-4 items-start" data-id="element-76">
          <div className="w-9 h-9 rounded-lg bg-[rgba(255,107,53,0.1)] flex items-center justify-center flex-shrink-0" data-id="element-77">
            <RocketIcon className="w-4 h-4 text-[#ff6b35]" data-id="element-78" />
          </div>
          <div data-id="element-79">
            <p className="text-xl font-bold text-white mb-1" data-id="element-80">Go-to-Market</p>
            <p className="text-[17px] text-white/70 leading-relaxed" data-id="element-81">
              Grow dev community, build sales team, attend key conferences, run
              pilot programs
            </p>
          </div>
        </motion.div>

        <motion.div variants={fadeUp} className="glass-card p-5 flex gap-4 items-start" data-id="element-82">
          <div className="w-9 h-9 rounded-lg bg-[rgba(0,212,255,0.1)] flex items-center justify-center flex-shrink-0" data-id="element-83">
            <ServerIcon className="w-4 h-4 text-[#00d4ff]" data-id="element-84" />
          </div>
          <div data-id="element-85">
            <p className="text-xl font-bold text-white mb-1" data-id="element-86">Infrastructure</p>
            <p className="text-[17px] text-white/70 leading-relaxed" data-id="element-87">
              Provision FPGA cloud capacity (rent or own)
            </p>
          </div>
        </motion.div>

        <motion.div variants={fadeUp} className="glass-card p-5 flex gap-4 items-start" data-id="element-88">
          <div className="w-9 h-9 rounded-lg bg-[rgba(255,107,53,0.1)] flex items-center justify-center flex-shrink-0" data-id="element-89">
            <UsersIcon className="w-4 h-4 text-[#ff6b35]" data-id="element-90" />
          </div>
          <div data-id="element-91">
            <p className="text-xl font-bold text-white mb-1" data-id="element-92">Team</p>
            <p className="text-[17px] text-white/70 leading-relaxed" data-id="element-93">
              Two to three key hires in engineering, developer relations, and
              business development
            </p>
          </div>
        </motion.div>
      </div>

      {/* Closing line */}
      <motion.div variants={fadeUp} className="mt-6 glass-card p-5 glow-cyan border-l-2 border-l-[#00d4ff]" data-id="element-94">
        <p className="text-[20px] text-white/90 leading-relaxed font-medium" data-id="element-95">
          We are making FPGAs as easy to use as GPUs. We are raising a pre-seed
          round to launch the first FPGA inference gateway and bring this to
          market.
        </p>
        <div className="flex items-center gap-2 mt-3 text-[#00d4ff] text-lg font-semibold" data-id="element-96">
          <span data-id="element-97">Let's talk</span>
          <ArrowRightIcon className="w-5 h-5" data-id="element-98" />
          <span className="text-[#8899aa] font-normal" data-id="element-99">
            founders@openfpga.ai
          </span>
        </div>
      </motion.div>
    </motion.div>;
}